export default __webpack_public_path__ + "static/media/reject.075060ab.svg";